import './index.scss'
import '../../assets/scripts/jquery.share.min.js'

$(document).ready(function(){
  $('.article img').each(function(index,value){
    if($(this).width() > 200){
      $(this).addClass('block')
    }
  })
})